import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { calendarTabs } from 'pages/tours/tours-calendar-page/model.ts'

import s from './styles.module.scss'

interface Props {
  dateText?: string
  nightsText?: string
  onClick: (type: string) => void
  defaultActive: string
}

export const DateAndNights = ({
  dateText,
  nightsText,
  onClick,
  defaultActive,
}: Props) => {
  const { t } = useTranslation()
  const [active, setActive] = useState(defaultActive)

  const handleClick = (type: string) => {
    setActive(type)

    onClick(type)
  }

  const dateTab = calendarTabs[0]
  const nightsTab = calendarTabs[1]

  return (
    <div className={s.container}>
      <div
        className={clsx(s.box, active === dateTab.path && s.active)}
        onClick={() => handleClick(dateTab.path)}
      >
        <div className={s.inputContainer}>
          <span className={clsx(s.subtitle, !dateText && s.subtitleEmpty)}>
            {t(dateTab.title)}
          </span>
          {dateText && <span className={s.title}>{dateText}</span>}
        </div>
      </div>

      <div
        className={clsx(s.box, active === nightsTab.path && s.active)}
        onClick={() => handleClick(nightsTab.path)}
      >
        <div className={s.inputContainer}>
          <span
            className={clsx(
              'medium-16',
              s.subtitle,
              !nightsText && s.subtitleEmpty,
            )}
          >
            {t(nightsTab.title)}
          </span>
          {nightsText && (
            <span className={clsx('medium-16', s.title)}>{nightsText}</span>
          )}
        </div>
      </div>
    </div>
  )
}
